import { Breadcrumbs, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { UserForm } from "components/user-form";
import { Link } from "react-router-dom";
import ROUTE_NAMES from "routes/routeNames";

const AddUser = () => {
    return (
        <Box>
            <Typography gutterBottom variant='h1' fontWeight={700}>
                User
            </Typography>
            <Breadcrumbs>
                <Link to={ROUTE_NAMES.MAIN_ROUTES.DASHBOARD}>User</Link>
                <Link to='#'>Add User</Link>
            </Breadcrumbs>
            <Box my={1}>
                <UserForm />
            </Box>
        </Box>
    );
};
export default AddUser;
